import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { IGetAppListData, IConsListData, Scheduletype } from '../upgrade/upgrade.component'
import { AuthService } from 'app/auth/auth.service';
import { DatePipe } from '@angular/common';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { MatDialog } from '@angular/material/dialog';
import { UserTypeList } from 'app/dashboard/Models/usertypelist.model';

export interface IDoctor_time_info {
  appId:number;
  time: string;
  patientId: number;
  patientName: string;
  age:number;
  apptType:string;
  contactNo:string;
  referredBy:string;
  slotLimit:number;
  remarks:string;
  fK_TakenOnId:number;
  takenOn:string;
  isBlock:boolean;
  isCancelled:boolean;
  isConfirm:boolean;
}
 
@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
 
 //live server url
 //baseUrl:string = "http://49.50.108.154:7575/api/";
 //baseUrl:string = "http://localhost:54923/api/";
 public scheduleid=1;
 todaysdate = this.authservice.localDate;
 public DoctorId:any="4";
 public DoctorIdOnline="4";
 public selectedDate:string;
 public fromselectedDate:string;
 public selectedDateOnline:string;
 public selectedDateList:string;
 public selectfromdatelist:string;
 public selectfromdata:any;
 public selectedDateListOnline:string;
 public FK_DoctorId=0;
 public Reported:string="status";
 public Cancelled:string="status";
 public Surgery:any;
 public Surgeryid:string;
 public allPatient:boolean;
 public allPatientCons:boolean;
 public PatientId:any = 0;
 public ApptStatus:string;
 public addAppDate:string;
 public times:string;
 public Doctor_time_info_Mod=[];
 //by Om from Sachin
// public morning_schedule = [];
// public afternoon_schedule = [];
// public evening_schedule = [];
// public  night_schedule = [];
public current_schedule = 1;
public selecteddoctor: string;
public docotrSlot=[];
public fullviewArray:any=[];
public doctors: UserTypeList[] = [];
// end sachin code
 //
  

constructor(private http: HttpClient,public authservice: AuthService,private datePipe: DatePipe,  public dashboardService: DashboardService,public dialog: MatDialog) { }
//selecteddate = this.datePipe.transform(this.todaysdate,"yyyy-MM-dd")

testappointment_services(){
console.log("app services working");
};



get_Transfer_Doctor(DoctorId:any,selectedDate:any) {
  return this.http.get<any>(this.dashboardService.newbaseUrl+"OpdDoctorSchedule/GetSchedule/"+DoctorId+"/"+ this.authservice.Loggeduser.branchid+"/"+selectedDate)
}
  Doctor_time_info_Method(bachid) : Observable<IDoctor_time_info[]>
 {
  
//  this.Doctor_time_info_Mod:Observable<IDoctor_time_info[]>= this.http.get<IDoctor_time_info[]>(this.dashboardService.baseUrl+"OpdDoctorSchedule/GetSchedule/"+this.DoctorId+"/"+ this.authservice.Loggeduser.branchid+"/1/"+this.selectedDate);
  return this.http.get<IDoctor_time_info[]>(this.dashboardService.newbaseUrl+"OpdDoctorSchedule/GetSchedule/"+this.DoctorId+"/"+ bachid+"/"+this.selectedDate);
  
}
Doctor_time_Schedule_Method(DoctorId,bachid,datedata)
{ 
 return this.http.get<any>(this.dashboardService.newbaseUrl+"OpdDoctorSchedule/GetSchedule/"+DoctorId+"/"+ bachid+"/"+datedata);
 
}
groupArr:any;

appsuccesslist(data)
{  
  
  this.Doctor_time_info_Mod=[];
  this.fullviewArray=[];
  this.docotrSlot=data;
  this.fullviewArray =data;
  this.groupArr = data.reduce((r,{scheduleType})=>{
    if(!r.some(o=>o.scheduleType==scheduleType)){
      r.push({scheduleType,groupItem:data.filter(v=>v.scheduleType==scheduleType)});
}
return r;
},[]);
  this.Doctor_time_info_Mod= this.groupArr;
 
 // this.setschedules();
}

errlist(err)
{
 this.dialog.closeAll();
 this.Doctor_time_info_Mod=[];
 if(err.status==403){
  this.dashboardService.openSnackBar("You Don't have Permission", "OK");
}else{
  this.dashboardService.openSnackBar("API Failed", "OK");
}
}
setschedules (){
  // this.get_morning_schedule();
  // this.get_noon_schedule();
  // this.get_evening_schedule();
  // this.get_night_schedule();  
  //this.setdefault_time(); 
 
   } 
  //  setdefault_time(){
  //   const tdate = this.authservice.localDate;
  
  //   let time = tdate.toLocaleTimeString().split(" ", 2);
  //   let time_hours_minutes = time[0].split(":",3);
  
  //   if(
  //     (time[1] == "AM") 
  //     && (parseInt(time_hours_minutes[0]) > 0  && parseInt(time_hours_minutes[0]) <= 12) )
  //     {
  //       this.current_schedule = 1;
  //     }
  //   else if(
  //     (time[1] == "PM") 
  //     && (parseInt(time_hours_minutes[0]) > 0  && parseInt(time_hours_minutes[0]) < 3)
  //     || (parseInt(time_hours_minutes[0]) == 12)
  //     )
  //     {
  //       this.current_schedule = 2;
  //     }
  
  //    else if(
  //       (time[1] == "PM") 
  //       && (parseInt(time_hours_minutes[0]) >= 3  && parseInt(time_hours_minutes[0]) < 5) )
  //       {
  //         this.current_schedule = 3;
  //         console.log("name changed " + this.current_schedule);
  //       }
  
  //      else if(
  //         (time[1] == "PM") 
  //         && (parseInt(time_hours_minutes[0]) >= 5  && parseInt(time_hours_minutes[0]) <= 11) )
  //         {
  //           this.current_schedule = 4;
  //         }
  //   }
//  get_morning_schedule(){
//    this.morning_schedule = this.Doctor_time_info_Mod.filter(item =>
//      (item.time.indexOf('AM') > -1)&&
     
//        (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 0
//        && 
//        parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 12
//       )
//      );
//  }
//  get_noon_schedule(){
//    this.afternoon_schedule= this.Doctor_time_info_Mod.filter(item =>
//      (item.time.indexOf('PM') > -1)&&
//      (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) == 12)||
//        (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) > 0
//        && 
//        parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) < 3
//       )
//      );
//  }
//  get_evening_schedule(){
//    this.evening_schedule = this.Doctor_time_info_Mod.filter(item =>
//      (item.time.indexOf('PM') > -1)&&
     
//        (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) >= 3
//        && 
//        parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <5
//       )
//      );
//  }
//  get_night_schedule(){
//    this.night_schedule = this.Doctor_time_info_Mod.filter(item =>
//      (item.time.indexOf('PM') > -1)&&
     
//        (parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) >= 5
//        && 
//        parseInt(item.time.split(" ", 2)[0].split(":", 2)[0]) <= 11
//       )
//      );
//  }


showRec(branchid){

   if( parseInt(this.selectedDate)>0)
   {
      if (parseInt(this.DoctorId)>0)
      {
      
       this.Doctor_time_info_Method(branchid).subscribe(data => this.appsuccesslist(data)
       , err => this.errlist(err));
      }
      else
      {
        alert("Please Select Date!");
      }
   }
}

//todate ,branchid ,doctorid,uhid, surgrytypeid, fromdate
ConsListData(fromdate:any,branchid:any,doctorid:any,uhid:any,surgrytypeid:any,todate:any) : Observable<IConsListData[]>
 {
    return this.http.get<IConsListData[]>(this.dashboardService.newbaseUrl+"Councelor/GetListStatus/"+fromdate+"/"+branchid+"/"+doctorid+"/"+surgrytypeid +"/"+this.authservice.Loggeduser.specialityId+"/" +todate+"/"+uhid);

//   //  return this.http.get<IConsListData[]>("http://localhost:54923/api/OpdAppointment/AppListAll/2019-11-14/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId+"/"+this.Reported+"/"+this.Cancelled);  
//   //alert(this.Surgery);
//     if (this.allPatientCons  ==true)
//   {
//     //alert("Final Testing=br-"+this.authservice.Loggeduser.branchid+"dr-"+this.FK_DoctorId);
//       // return this.http.get<IConsListData[]>("http://localhost:54923/api/Councelor/GetList/2019-08-21/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
//       return this.http.get<IConsListData[]>(this.dashboardService.newbaseUrl+"Councelor/GetList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId +"/"+this.authservice.Loggeduser.specialityId);
//   }
//   else if (this.PatientId >0)
//   {
//     //alert(this.PatientId);
//     return this.http.get<IConsListData[]>(this.dashboardService.newbaseUrl+"Councelor/GetList/"+this.selectedDateList +"/"+this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId+"/"+this.PatientId +"/"+this.authservice.Loggeduser.specialityId);
//   }
//   else
//   {
//     return this.http.get<IConsListData[]>(this.dashboardService.newbaseUrl+"Councelor/GetListStatus/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId+"/"+this.Surgery  +"/"+this.authservice.Loggeduser.specialityId);

//   }

}


GetAppListData() : Observable<IGetAppListData[]>
{ 
  //return this.http.get<IDoctor_time_info[]>(this.baseUrl1);
  // 
  //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
  //return this.http.get<IGetAppListData[]>("http://localhost:54923/api/OpdAppointment/AppList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
 // alert(this.Reported+ " "+this.Cancelled);
  if (this.Reported != 'status' && this.Cancelled !='status')
  {
   // alert("Upper Final Testing");
    return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppListAll"+"/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId+"/"+this.Reported+"/"+this.Cancelled);  
  }
  if (this.allPatient==true)
  {
   // alert("Final Testing");
      return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppList"+"/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
  }

}
GetAppListDataOnline() : Observable<IGetAppListData[]>
{
  
 // alert(this.ApptStatus);
  if (this.ApptStatus=="All")
  {
  //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
  //return this.http.get<IGetAppListData[]>("http://localhost:54923/api/OpdAppointment/AppList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
  return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppTakenBy/"+this.selectedDateListOnline+"/"+ this.authservice.Loggeduser.branchid +"/"+ this.authservice.Loggeduser.specialityId);
  }
  if (this.ApptStatus=="Reported")
  {
  //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
  //return this.http.get<IGetAppListData[]>("http://localhost:54923/api/OpdAppointment/AppList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
  return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppTakenByConfirm/"+this.selectedDateListOnline+"/"+ this.authservice.Loggeduser.branchid +"/"+ this.authservice.Loggeduser.specialityId);
  }
  if (this.ApptStatus=="Cancelled")
  {
  //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
  //return this.http.get<IGetAppListData[]>("http://localhost:54923/api/OpdAppointment/AppList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
  return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppTakenByCancel/"+this.selectedDateListOnline+"/"+ this.authservice.Loggeduser.branchid +"/"+ this.authservice.Loggeduser.specialityId);
  }
  if (this.ApptStatus=="Pending")
  {
  //http://localhost:54923/api/OpdDoctorSchedule/GetSchedule/DoctorId/branchId/scheduleTypeId/ScheduleDate
  //return this.http.get<IGetAppListData[]>("http://localhost:54923/api/OpdAppointment/AppList/"+this.selectedDateList+"/"+ this.authservice.Loggeduser.branchid+"/"+this.FK_DoctorId);
  return this.http.get<IGetAppListData[]>(this.dashboardService.newbaseUrl+"OpdAppointment/AppTakenByPending/"+this.selectedDateListOnline+"/"+ this.authservice.Loggeduser.branchid +"/"+ this.authservice.Loggeduser.specialityId);
  }
}

getScheduleType() : Observable<Scheduletype[]>
{
  return this.http.get<any>(this.dashboardService.newbaseUrl+"ScheduleTypeMaster/GetAll");
}
getAppointmentUpdte(AppId:any,AppDate:any,AppTime:any,docotrid:any,scid:any,branchid:any) {
  return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/TransferAppt/"+AppId+"/"+AppDate+"/"+AppTime+"/"+docotrid +"/"+scid+"/"+branchid)
}

  // appointment doctor's list
  app_doctors(type ,branchid:any,date:any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "VisitMaster/GetUserByUserTypeId_apointment/"+type
      + "/" + branchid + "/" + date + "/6" +'/'+this.authservice.Loggeduser.specialityId);
  }

  getReportingType() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "common/GetStatusByType/REPORTING");
  }
  getReportCancel() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "common/GetStatusByType/CANCEL");
  }
  getBrachMaster() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "BranchMaster/GetBranch/" + 0)
  }
  getTempMaster(branchid:any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "SendSMS/GetSmsTemplateMasterById/" + branchid + "/"+ 0)
  }
  getSMSTempMaster(branchId: any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "SendSMS/GetSmsTemplateMasterById/"+ branchId + "/" + 0)
  }
  getAppointmentList(branchId: any, apptdate: any, doctorid: any, reportstatus:any, cancelstatus:any) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Appointment/GetAppointmentListFromDateToDate/" + branchId + "/" + apptdate + "/" + doctorid + "/" + reportstatus + "/" + cancelstatus + "/" + this.authservice.Loggeduser.specialityId);
  }
  getappoitmentType() {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Appointment/GetAppointmentMaster");
  }
  getappoitmentTrackin(appointmentid) {
    return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetOpdAppointmentTrackingByAppointmentId/"+appointmentid + "/" + this.authservice.Loggeduser.specialityId);
  }
  //pop up GetPopUpHelp
  GetPopUpHelp(parameter) {
    return this.http.get(this.dashboardService.newbaseUrl + "Common/GetPopUpHelp/" + parameter);
  }
  GetPatientBySearchTypeByValueOrderBy(Searchtype,ValuePara,OrderBy){
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Patientregistration/GetPatientBySearchTypeByValueOrderBy/" + Searchtype + "/" + ValuePara + "/" + OrderBy);
  }
  InsertMultipleAppointment(payload){
    return this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/InsertMultipleAppointment", payload);
  }
  holidayMasterbybranchid(branchid,years){
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Configuration/GetHolidayMasterByBranchId/"+branchid+'/'+years);
  }
  insertHolidayMaster(payload){
    return this.http.post<any>(this.dashboardService.newbaseUrl + "Configuration/InsertHolidayMaster", payload);   
  }
  ReActiveCancelAppointment(payload){
    return this.http.post<any>(this.dashboardService.newbaseUrl + "OpdAppointment/ReActivate", payload);
  }
  GetNameByType(parameter){
    return this.http.get<any>(this.dashboardService.newbaseUrl + "Common/GetNameByType/"+ parameter);
  }
  GetDoctorAppointmentSummary(fdate,tdate,branchid,sepecilty){

    return this.http.get<any>(this.dashboardService.newbaseUrl + "OpdAppointment/GetDoctorAppointmentSummaryByFromDateToDateBranchIdSubSpeciality/"+ fdate +'/'+tdate+'/'+branchid+'/'+sepecilty + "/" + this.authservice.Loggeduser.specialityId);
    
  }

  getSMSTEMPLATE(){
   return this.http.get<any>(this.dashboardService.newbaseUrl + "Common/GetNameByType/SMSTEMPLATEPARAMETERS") 
}

  getConuSugeryStatus() {
   return this.http.get(this.dashboardService.newbaseUrl + "SurgeryMaster/GetSurgeryStatusMaster/All");
  }
 
}
   